// pause previous player on play
(() => {
  document.addEventListener('play', (event) => {
    const currentMedia = event.target;

    if (!currentMedia.matches('audio, video')) return;

    document.querySelectorAll('audio, video').forEach((media) => {
      if (media !== currentMedia && !media.paused) {
        media.pause();
      }
    });
  }, true);
})();